import { PLFlag, GBFlag, DEFlag } from 'mantine-flagpack';
import { pl, enGB, de } from 'date-fns/locale';

const LANGUAGES = {
	PL: {
		name: 'Polski',
		code: 'pl',
		displayCode: 'PL',
		flag: PLFlag,
		dateFnsLocale: pl,
	},
	EN: {
		name: 'English',
		code: 'en',
		displayCode: 'EN',
		flag: GBFlag,
		dateFnsLocale: enGB,
	},
	DE: {
		name: 'Deutsch',
		code: 'de',
		displayCode: 'DE',
		flag: DEFlag,
		dateFnsLocale: de,
	},
} as const;

export default LANGUAGES;
